"use client"

import Button from "../buttons/Button";

interface PaymentModalProps {
  isOpen: boolean;
  remainingAmount: number;
  currency?: string;
  onProceed: () => void;
  dueCleared: boolean;
  pendingAmount: number;
  remainingCA: number;
  isZeroPayment?: boolean;
  primaryButtonText:string
  primaryButtonClassName?: string;
  buttonLoading:boolean;
  buttonColor?: string;
  buttonWidth?: string;
  handleclose:()=> void;
}

export default function PaymentModal({ 
  isOpen, 
  remainingAmount, 
  currency = "AFA", 
  onProceed,
  dueCleared,
  pendingAmount,
  remainingCA,
  isZeroPayment, 
  primaryButtonText,
  primaryButtonClassName,
  buttonLoading,
  buttonColor,
  buttonWidth,
  handleclose
}: PaymentModalProps) {
  if (!isOpen) return null;

  // Close modal when clicking outside
  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 shadow-lg"
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-lg p-6 shadow-xl max-w-md w-full mx-4 text-center animate-fadeIn" data-testid={"due_clearence_model"}>
      <div className="flex justify-end mb-4">
          <button
            onClick={handleclose}
            className="text-gray-500 hover:text-gray-700"
            aria-label="Close"
          >
            <img src="/images/close.svg" />
          </button>
        </div>
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 relative">
            {/* Payment Icon */}
            <div className="w-full h-full flex items-center justify-center">
              <img src="/images/clearDue.svg" alt="Payment" className="h-[160px] w-[160px]" />
            </div>
          </div>
        </div>

        {isZeroPayment ? (
          <>
            <h2 className="text-2xl font-bold mb-3 text-gray-800">No Payment made Toward Due</h2>
            <p className="text-gray-600 mb-6">
              {currency} {remainingCA.toFixed(2)} will be converted to E-Top-Up stocks
            </p>
          </>
        ) : dueCleared ? (
          <>
            <h2 className="text-2xl font-bold mb-3 text-gray-800">Due is Cleared</h2>
            {remainingCA > 0 && (
              <p className="text-gray-600 mb-6">
                Remaining confirmed amount of {currency} {remainingCA.toFixed(2)} will be converted to e-top up stocks
              </p>
            )}
          </>
        ) : (
          <>
            <h2 className="text-2xl font-bold mb-3 text-gray-800">
              {currency} {pendingAmount.toFixed(2)} Due Pending
            </h2>
            {remainingCA > 0 && (
              <p className="text-gray-600 mb-6">
                Remaining confirmed amount of {currency} {remainingCA.toFixed(2)} will be converted to e-top up stocks
              </p>
            )}
          </>
        )}

        <div className="mt-4">
        <Button
                buttonName={primaryButtonText}
                className={`py-2.5 ${primaryButtonClassName} px-4 rounded-[6px] `}
                textSize={'text-large'}
                buttonOnclick={onProceed}
                testId={`${primaryButtonText}-btn`}
                loading={buttonLoading}
                bgColor={buttonColor}
                buttonWidth={buttonWidth}
                buttonHight="h-[42px]"
              />
        </div>
      </div>
    </div>
  );
}